<!-- Filter Section - Shows active filters -->
<section class="filter-section"
         *ngIf="hasActiveFilters">
  <div class="filter-wrapper">
    <div *ngFor="let fieldName of getAppliedFiltersKeys()"
         class="column-filter-wrapper">
      <rappider-tag [mode]="filterTagConfig.mode.closeable"
                    (close)="onRemoveFilter(fieldName)"
                    class="filter-tag"
                    [text]="{
                      content: getFilterTagContent(fieldName),
                      textMode: filterTagConfig.text.textMode
                    }"
                    [icon]="filterTagConfig.icon">
      </rappider-tag>
    </div>

    <div class="clear-all-wrapper">
      <rappider-button [text]="clearAllFiltersConfig.text"
                       (click)="onClearAllFilters()"
                       [size]="clearAllFiltersConfig.size">
      </rappider-button>
    </div>
  </div>
</section>
